import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '240',
  height: '200',
  viewBox: '0 0 240 200'
}, [
  h('circle', {
    cx: '120',
    cy: '100',
    r: '100',
    fill: '#f4fffb'
  }),
  h('circle', {
    cx: '120',
    cy: '100',
    r: '70',
    fill: '#e6fff4'
  }),
  h('path', {
    d: 'M6.5 111c-.8-.8-1.9-1-2.9-.6S2 111.8 2 112.8v11.6c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.6-1.2 2.6-2.7V119c1 .4 2.2.3 3-.5 1-1 1-2.7 0-3.7L6.5 111zM191.7 143.4c-1-.4-2.1-.2-2.9.6l-3.8 3.8c-1 1-1 2.7 0 3.7.5.5 1.2.8 1.9.8.4 0 .8-.1 1.1-.2v5.4c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.6-1.2 2.6-2.7v-11.6c0-1.1-.6-2.1-1.6-2.5zM212.4 23.2l1.6-1.6c1.1-1.1 1.1-2.9 0-4s-2.9-1.1-4 0l-1.6 1.6-1.6-1.6c-1.1-1.1-2.9-1.1-4 0-.5.5-.8 1.3-.8 2 0 .8.3 1.5.8 2l1.6 1.6-1.6 1.6c-1.1 1.1-1.1 2.9 0 4 .6.6 1.3.8 2 .8s1.5-.3 2-.8l1.6-1.6 1.6 1.6c.5.5 1.2.8 2 .8s1.5-.3 2-.8c1.1-1.1 1.1-2.9 0-4l-1.6-1.6zM87 149.7c-1.5 0-2.7 1.2-2.7 2.7 0 1.5 1.2 2.7 2.6 2.7h.1c.5 0 1 .4 1 1v4.4c0 .5-.4 1-1 1h-.1c-.5 0-1-.4-1-1 0-1.5-1.2-2.7-2.7-2.7s-2.7 1.2-2.7 2.7c0 3.5 2.8 6.3 6.3 6.3h.2c3.5 0 6.3-2.8 6.3-6.3v-4.4c-.1-3.6-2.9-6.4-6.3-6.4zM64.5 28.4h-5.6c-2.6 0-4.7-2.1-4.7-4.7v-5.6c0-2.6 2.1-4.7 4.7-4.7h5.6c2.6 0 4.7 2.1 4.7 4.7v5.6c.1 2.6-2.1 4.7-4.7 4.7zm-5.6-11.2c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9h5.6c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.6z',
    fill: '#c0f2d6'
  }),
  h('path', {
    d: 'M118.5 130.8c-.2 0-.4 0-.6-.1l-33-15c-.5-.2-.9-.8-.9-1.4v-24c0-.5.3-1 .7-1.3.4-.3 1-.3 1.4-.1l33 15c.5.2.9.8.9 1.4v24c0 .5-.3 1-.7 1.3-.2.1-.5.2-.8.2zM87 113.3l30 13.6v-20.7L87 92.6v20.7z',
    fill: '#0eb87f'
  }),
  h('path', {
    d: 'M118.5 130.8c-.3 0-.6-.1-.8-.3-.4-.3-.7-.7-.7-1.2v-24c0-.6.4-1.2.9-1.4l36-15c.5-.2 1-.1 1.4.1s.7.7.7 1.2v24c0 .6-.4 1.2-.9 1.4l-36 15c-.2.1-.4.2-.6.2zm1.5-24.6V127l33-13.8V92.5l-33 13.7z',
    fill: '#0eb87f'
  }),
  h('ellipse', {
    cx: '120',
    cy: '91.8',
    rx: '9',
    ry: '4.5',
    fill: '#c0f2d6'
  }),
  h('path', {
    d: 'M120 97.8c-6 0-10.5-2.6-10.5-6s4.5-6 10.5-6 10.5 2.6 10.5 6-4.5 6-10.5 6zm0-9c-4.6 0-7.5 1.8-7.5 3s2.9 3 7.5 3 7.5-1.8 7.5-3-2.9-3-7.5-3z',
    fill: '#0eb87f'
  }),
  h('ellipse', {
    cx: '120',
    cy: '75.2',
    rx: '9',
    ry: '4.5',
    fill: '#c0f2d6'
  }),
  h('path', {
    d: 'M120 81.2c-6 0-10.5-2.6-10.5-6s4.5-6 10.5-6 10.5 2.6 10.5 6-4.5 6-10.5 6zm0-9c-4.6 0-7.5 1.8-7.5 3s2.9 3 7.5 3 7.5-1.8 7.5-3-2.9-3-7.5-3z',
    fill: '#0eb87f'
  }),
  h('ellipse', {
    cx: '141',
    cy: '84.2',
    rx: '9',
    ry: '4.5',
    fill: '#c0f2d6'
  }),
  h('path', {
    d: 'M141 90.2c-6 0-10.5-2.6-10.5-6s4.5-6 10.5-6 10.5 2.6 10.5 6-4.5 6-10.5 6zm0-9c-4.6 0-7.5 1.8-7.5 3s2.9 3 7.5 3 7.5-1.8 7.5-3-2.9-3-7.5-3z',
    fill: '#0eb87f'
  }),
  h('ellipse', {
    cx: '100.5',
    cy: '84.2',
    rx: '9',
    ry: '4.5',
    fill: '#c0f2d6'
  }),
  h('path', {
    d: 'M100.5 90.2c-6 0-10.5-2.6-10.5-6s4.5-6 10.5-6 10.5 2.6 10.5 6-4.5 6-10.5 6zm0-9c-4.6 0-7.5 1.8-7.5 3s2.9 3 7.5 3 7.5-1.8 7.5-3-2.9-3-7.5-3z',
    fill: '#0eb87f'
  }),
  h('path', {
    d: 'M85.5 91.8c-.6 0-1.1-.3-1.4-.9-.3-.8 0-1.6.8-2l7.7-3.4c.8-.3 1.6 0 2 .8.3.8 0 1.6-.8 2l-7.7 3.4c-.2 0-.4.1-.6.1zM106.7 82.5c-.6 0-1.1-.3-1.4-.9-.3-.8 0-1.6.8-2l6.5-2.8c.8-.3 1.6 0 2 .8.3.8 0 1.6-.8 2l-6.5 2.8c-.2.1-.4.1-.6.1zM134.1 82.9c-.2 0-.4 0-.6-.1l-7.3-3.2c-.8-.3-1.1-1.2-.8-2 .3-.8 1.2-1.1 2-.8l7.3 3.2c.8.3 1.1 1.2.8 2-.3.5-.8.9-1.4.9zM154.5 91.8c-.2 0-.4 0-.6-.1l-6.9-3c-.8-.3-1.1-1.2-.8-2 .3-.8 1.2-1.1 2-.8l6.9 3c.8.3 1.1 1.2.8 2-.3.5-.8.9-1.4.9z',
    fill: '#0eb87f'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/empty-content-model.es6.js